function fromatDateintoDDMMMMYYYY(dateString) {
    if (!dateString) {
      return null; // Return null for invalid or missing dates
    }
  
    try {
      const date = new Date(dateString);
      const options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true, // Use 12-hour format (AM/PM)
      };
      
  
      return new Intl.DateTimeFormat('en-US', options).format(date);
    } catch (error) {
      console.error('Error formatting date:', error);
      return null; // Return null in case of parsing errors
    }
  }
  
  export default fromatDateintoDDMMMMYYYY;